'use strict';

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-nan");

module.exports = Number.isNaN || function isNaN(a) {
  return a !== a;
};